class Segments {
    constructor(
        permissionId,
        id,
        numberSequence,
        name,
        days,
        shiftTravel,
        typeShift,
        requiredPin,
        requiredCacheo,
        requiredPassBack,
        porcentCacheo
    ) {
        this.permissionId = permissionId;
        this.id = id;
        this.numberSequence = numberSequence;
        this.name = name;
        this.days = days;
        this.shiftTravel = shiftTravel;
        this.typeShift = typeShift;
        this.requiredPin = requiredPin;
        this.requiredPinIcon = Segments.getIconForRequirement(this.requiredPin);
        this.requiredCacheo = requiredCacheo;
        this.requiredCacheoIcon = Segments.getIconForRequirement(this.requiredCacheo);
        this.requiredPassBack = requiredPassBack;
        this.requiredPassBackIcon = Segments.getIconForRequirement(this.requiredPassBack);
        this.porcentCacheo = porcentCacheo;
        this.subtitle=this.numberSequence
    }

    static fromJson({
        permisoId,
        segmId,
        numSecuencia,
        nombre,
        dias,
        desplJornada,
        tipoJornada,
        reqPin,
        reqCacheo,
        reqPassBack,
        porcenCacheo
    }) {
        return new Segments(
            permisoId,
            segmId,
            numSecuencia,
            nombre,
            dias,
            desplJornada,
            tipoJornada,
            reqPin,
            reqCacheo,
            reqPassBack,
            porcenCacheo
        );
    }

    static getIconForRequirement(value) {
        switch (value) {
            case 0:
                return '❌'; // No
            case 1:
                return '✅'; // Sí
            case 2:
                return '➖'; // No definido (alternativa)
            default:
                return '➖'; // Por si acaso
        }
    }
}

export default Segments;
